import {getNonProdStageLabel} from '@hconnect/common/appStages'
import {Icon, LabelSmallMedium} from '@hm/fundamental'
import {mdiAlert} from '@mdi/js'
import React from 'react'

import {useUikitTranslation} from '../../common'

// keep in sync with the height reserved for it in HeaderContainer
export const ENV_BANNER_HEIGHT = 32

// Persistent notice shown on every non-production stage (qa/uat/uatr), hidden on prod
export const EnvironmentBanner: React.FC = () => {
  const {t} = useUikitTranslation()
  const stageLabel = getNonProdStageLabel()

  if (!stageLabel) {
    return null
  }

  return (
    <div
      data-test-id="environment-banner"
      className="w-full h-32px flex items-center justify-start gap-2 px-4 bg-warning text-foreground_inverted overflow-hidden whitespace-nowrap"
    >
      <Icon path={mdiAlert} size="regular" className="text-foreground_inverted shrink-0" />
      <LabelSmallMedium className="text-foreground_inverted overflow-hidden text-ellipsis">
        {t('environmentBanner.message')}
      </LabelSmallMedium>
    </div>
  )
}
